<template>
  <v-form ref="form" @submit.prevent="submit" lazy-validation v-model="valid">
    <v-container :class="$vuetify.breakpoint.xsOnly ? '' : 'elevation-2'">
      <v-text-field
        v-if="!this.campo || this.campo === 'nombre'"
        :label="labels.name"
        v-model="form.name"
        :error-messages="errors.name"
        :rules="[rules.required('name')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        v-if="!this.campo || this.campo === 'correo_electronico'"
        :label="labels.email"
        v-model="form.email"
        :error-messages="errors.email"
        :rules="[rules.required('email')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        v-if="!this.campo || this.campo === 'contraseña'"
        :label="labels.new_password"
        v-model="form.password"
        :append-icon="passwordHidden ? 'visibility_off' : 'visibility'"
        @click:append="() => (passwordHidden = !passwordHidden)"
        :type="passwordHidden ? 'password' : 'text'"
        :error-messages="errors.password"
        :disabled="loading"
        hint="Al menos 6 caracteres."
        autocomplete="new-password"
      ></v-text-field>

      <v-text-field
        v-if="!this.campo || this.campo === 'contraseña'"
        :label="labels.new_password_confirmation"
        v-model="form.password_confirmation"
        :type="passwordHidden ? 'password' : 'text'"
        :error-messages="errors.password_confirmation"
        :disabled="loading"
        autocomplete="new-password"
      ></v-text-field>

      <v-select
        v-if="!this.campo || this.campo === 'rol'"
        :label="labels.role"
        v-model="form.role"
        :items="roles"
        :error-messages="errors.role"
        :rules="[rules.required('role')]"
        :disabled="loading"
        dense
      ></v-select>

      <v-autocomplete
        v-if="!this.campo || this.campo === 'campuses'"
        @keyup.enter="$event.target.blur()"
        :label="labels.campuses_a_cargo"
        v-model="form.campuses"
        :disabled="loading"
        :items="campuses"
        item-text="nombre"
        item-value="uuid"
        attach
        chips
        multiple
        deletable-chips
        hide-no-data
      ></v-autocomplete>
    </v-container>

    <v-layout justify-end mt-2>
      <v-btn
        flat
        :disabled="loading"
        @click="$router.go(-1)"
        color="grey darken-2"
      >
        Cancelar
      </v-btn>

      <v-btn
        type="submit"
        :loading="loading"
        :disabled="loading"
        color="primary"
      >
        Guardar
      </v-btn>
    </v-layout>
  </v-form>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { api } from '~/config'
  import Form from '~/mixins/form'

  export default {
    mixins: [Form],

    data: () => ({
      passwordHidden: true,
      form: {},
      campuses: [],
      cargos: [],
      roles: ['Administrador', 'Escolares'],
      campo: null
    }),

    computed: mapGetters({
    }),

    mounted() {
      if(this.$route.params.campo) {
        this.campo = this.$route.params.campo
      } else {
        let tab = this.$route.fullPath.replace(this.$route.path, '').split('/')
        let param = decodeURI(tab[0].substr(1))
        if (
          param === 'nombre' ||
          param === 'correo_electronico' ||
          param === 'contraseña' ||
          param === 'rol' ||
          param === 'campuses'
        ) {
          this.campo = param
        }
      }

      if(this.campo) {
        this.$router.replace('#' + this.campo)
      }

      if(!this.campo || this.campo === 'campuses') {
        this.getCampuses()
      }

      if(this.campo !== 'contraseña') {
        this.getUsuario(this.$route.params.id)
      }
    },

    methods: {
      getUsuario(id) {
        this.loading = true
        axios
          .get(api.path('usuarios.single', { id: id } ), {
            params: {
              campo: this.campo
            }
          })
          .then(res => {
            this.form = res.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {
            this.loading = false
          })
      },

      getCampuses() {
        axios
          .get(api.path('campus'))
          .then(res => {
            this.campuses = res.data.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      submit() {
        if (this.$refs.form.validate()) {
          this.loading = true

          axios.put(api.path('usuarios.single', { id: this.$route.params.id }), this.form)
            .then(res => {
              this.$toast.success('Usuario actualizado correctamente.')
              this.$emit('success', res.data)
            })
            .catch(err => {
              this.handleErrors(err.response.data.errors)
            })
            .then(() => {
              this.loading = false
            })
        }
      }
    }
  }
</script>
